<template>
  <div class="layout-box flex-column-box">
    <!--巨图-->
    <!-- <van-image
      v-if="tabbarActive !== showActiveNum"
      width="100%"
      height="150px"
      fit="fill"
      :src="hospitalInfo.hospitalImage | showImgUrl"
      @click="toPage('/yiyuanjieshao')"
    /> -->
    <div v-if="tabbarActive !== showActiveNum" class="layout-title-box">
      <div class="layout-title-img">
        <van-image
          width="100%"
          height="100%"
          fit="fill"
          :src="hospitalInfo.hospitalImage | showImgUrl"
          @click="toPage('/yiyuanjieshao')"
        />
      </div>
    </div>
    <div v-if="tabbarActive !== showActiveNum" class="middle-box">
      <!-- <div class="guanhuai" @click="changeModule">
        <div class="guanhuai_detail">
          <div class="pic">
            <img src="../../assets/images/test/care.png" alt="" style="width:100%;height:100%;">
            <img src="../../assets/images/guanhuai.png" alt="" style="width:100%;height:100%;">
          </div>
          <div style="margin-left:5px">
            关怀模式
          </div>
        </div>
      </div> -->
      <!--宫格菜单-->
      <!-- <van-grid v-if="tabbarActive !== showActiveNum" :column-num="4">
        <van-grid-item
          v-for="(item, index) in menuList[tabbarActive].childList"
          :key="`frid${index}`"
          @click="toPage(item.path)"
        >
          <img
            slot="icon"
            :src="item.icon"
            alt=""
            class="grid-icon iconfont iconfont-blue"
            style="width:50%;margin-left:25px"
          >
          <span slot="text" class="grid-text">{{ item.title }}</span>
        </van-grid-item>
      </van-grid> -->
      <div v-if="tabbarActive !== showActiveNum" class="menu-box">
        <div
          v-for="(item, index) in menuList[tabbarActive].childList"
          :key="`frid${index}`"
          class="menu-data"
          @click="toPage(item.path)"
        >
          <img
            slot="icon"
            :src="item.icon"
            alt=""
            class="grid-icon iconfont iconfont-blue"
            style="width:50%"
          >
          <span slot="text" class="grid-text">{{ item.title }}</span>
        </div>
      </div>
    </div>
    <!--我的菜单-->
    <User v-if="tabbarActive === showActiveNum" :user-info="$store.state.userInfo" />
    <!--底部导航-->
    <van-tabbar v-model="tabbarActive" safe-area-inset-bottom>
      <van-tabbar-item v-for="(item, index) in tabbarList" :key="`tabbar${index}`" @click="changeTabbarActive(index)">
        <div class="tabbar-title">{{ item.title }}</div>
        <i slot="icon" class="tabbar-icon iconfont" :class="item.icon" />
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import imageFile from '../../assets/images/public/yyLogo.png'
import mixin from '../../mixins'
import User from '../../views/user/index.vue'

export default {
  name: 'Layout',
  components: {
    User
  },
  mixins: [mixin],
  data() {
    return {
      hospitalInfo: {},
      faceImage: require('../../assets/images/default.png'),
      openId: '',
      text: '',
      imageFile: imageFile,
      userInfo: {},
      showoutPatienteNum: 0,
      menuList: [
        {
          name: '门诊',
          childList: [
            {
              title: '预约挂号',
              icon: require('../../assets/images/myPeople.png'),
              path: '/guahaofangshi'
            },
            {
              title: '挂号记录',
              icon: require('../../assets/images/guahao.png'),
              path: '/myPatient?url=guahaojilu'
            },
            {
              title: '报告查询',
              icon: require('../../assets/images/myPeople.png'),
              path: '/myPatient?url=baogaolist'
            },
            {
              title: '自费缴费',
              icon: require('../../assets/images/payMoney.png'),
              path: '/myPatient?url=menzhenjiaofei'
            },
            {
              title: '缴费记录',
              icon: require('../../assets/images/payMoney.png'),
              path: '/myPatient?url=menzhenjiaofeijilu'
            },
            {
              title: '就诊人信息',
              icon: require('../../assets/images/myPeople.png'),
              path: '/myPatient'
            },
            {
              title: '我要复诊',
              icon: require('../../assets/images/myPeople.png'),
              path: '/myPatient?url=fuzhen'
            },
            {
              title: '健康头条',
              icon: require('../../assets/images/myPeople.png'),
              path: '/healthy'
            }
          ]
        },
        {
          name: '住院',
          active: 1,
          childList: [
            {
              title: '补缴押金',
              icon: require('../../assets/images/payMoney.png'),
              path: '/myPatient?url=yajinbujiao'
            },
            {
              title: '补缴记录',
              icon: require('../../assets/images/addRecharg.png'),
              path: '/myPatient?url=yajinbujiaorecord'
            }
            // {
            //   title: '住院报告',
            //   icon: require('../../assets/images/guahao.png'),
            //   path: '/zhuyuanbaogaorecord'
            // },
            // {
            //   title: '住院人信息',
            //   icon: require('../../assets/images/hospitalInfo.png'),
            //   path: '/inpatient-personList?link=inpatient-edit'
            // }
          ]
        },
        /* {
          name: '医院信息',
          active: 2,
          childList: [
            {
              title: '医院介绍',
              icon: 'icon-yiyuanjieshao',
              path: '/yiyuanjieshao'
            },
            {
              title: '科室介绍',
              icon: 'icon-keshijieshao',
              path: '/keshijieshao'
            },
            {
              title: '医生介绍',
              icon: 'icon-yishengyishengjieshao',
              path: '/yishengjieshao'
            },
            {
              title: '来院导航',
              icon: 'icon-daohangdizhi',
              path: '/tMap'
            },
            {
              title: '楼群分布',
              icon: 'icon-louceng',
              path: '/loucengfenbu'
            },
            {
              title: '医院动态',
              icon: 'icon-dongtai',
              path: '/dynamic'
            }
          ]
        }, */
        {
          name: '体检',
          active: 2,
          childList: [
            {
              title: '体检预约',
              icon: require('../../assets/images/test/tjyy.png'),
              path: '/tijianyuyue'
            },
            {
              title: '预约记录',
              icon: require('../../assets/images/test/yyjl.png'),
              path: '/yuyuejilu'
            },
            {
              title: '体检报告',
              icon: require('../../assets/images/test/tjbg.png'),
              path: '/tijianren?url=tijianbaogao'
            },
            {
              title: '体检人信息',
              icon: require('../../assets/images/test/tjrxx.png'),
              path: '/tijianren'
            }
          ]
        },
        {
          name: '我的',
          active: 3,
          childList: [
            {
              title: '在线客服',
              icon: require('../../assets/images/guahaoRecord.png'),
              path: '/guahaojilu'
            },
            {
              title: '电话客服',
              icon: require('../../assets/images/guahaoRecord.png'),
              path: '/guahaojilu'
            },
            {
              title: '意见反馈',
              icon: require('../../assets/images/guahaoRecord.png'),
              path: '/feedback'
            },
            {
              title: '常见问题',
              icon: require('../../assets/images/guahaoRecord.png'),
              path: '/dynamic'
            }
          ]
        }
      ],
      tabbarList: [
        {
          title: '门诊',
          icon: 'icon-menzhen-01'
        },
        {
          title: '住院',
          icon: 'icon-zhuyuan'
        },
        {
          title: '体检',
          icon: 'icon-yiyuanjieshao'
        },
        {
          title: '我的',
          icon: 'icon-wode'
        }
      ],
      tabbarActive: 0,
      showActiveNum: 3
    }
  },
  mounted() {
    if (sessionStorage.getItem('url_link')) {
      this.$router.push(sessionStorage.getItem('url_link'))
      sessionStorage.removeItem('url_link')
      return
    }
    if (this.$route.query && this.$route.query.type) {
      this.changeTabbarActive(this.$route.query.type * 1)
    }
    this.tabbarActive = this.$store.state.tabbarActive
    this.getHospitalDetail()
  },
  methods: {
    changeModule() {
      this.$store.commit('switchCareMode', true)
      this.$router.push({
        path: '/careMode'
      })
    },
    addPatient() {
      this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
    },
    goDeposit() {
      if (this.tabbarActive === 1 && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push({
        path: '/yajinbujiao'
      })
    },
    gohospitalRecord() {
      if (this.tabbarActive === 1 && !this.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push({
        path: '/zhuyuanbaogaorecord'
      })
    },
    checkreportQuery() {
      this.$router.push({
        path: 'myPatient?url=baogaolist'
      })
    },
    goMoney() {
      this.$router.push({
        path: '/menzhenjiaofei'
      })
    },
    toPage(url) {
      if (!url) return
      if (!this.$store.state.userInfo) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '请先添加就诊人'
          })
          .then(() => {
            this.$router.push(`/addPatient?id=${this.$store.state.openId}&isNotSelf=1`)
          })
          .catch(() => {
            return false
          })
        return
      }
      this.$router.push(url)
    },
    changeTabbarActive(index) {
      localStorage.setItem('tabbarActive', index)
      this.$store.commit('updateInfo', {
        name: 'tabbarActive',
        value: index
      })
    },
    wechatUserInfo() {
      this.wechatUserInfo().then(res => {
        console.log(res)
      })
    },
    // getByAppletsId() {
    //   this.$Apis.getByAppletsId({ appletsId: this.openId }).then(res => {
    //     if (res.code === 200) {
    //       this.userInfo = res.data || {}
    //       alert(2333)
    //       localStorage.setItem('userInfo', JSON.stringify(res.data))
    //       this.$store.commit('updateInfo', {
    //         name: 'userInfo',
    //         value: res.data
    //       })
    //       if (res.data.patientSfzh) {
    //         // this.precheckGetListFun(res.data.patientSfzh)
    //       }
    //     }
    //   })
    // },
    // precheckGetListFun (sfzh) {
    //   const time = this.$utils.dateFormat('YYYY-mm-dd', new Date())
    //   this.$Apis.precheckGetList({ sfzh, startTime: `${time} 00:00:00`, endTime: `${time} 23:59:59` }).then(res => {
    //     if (res.code === 200 && !res.data.length) {
    //       this.$router.push({ path: '/yujianfenzhenForm' })
    //     }
    //   })
    // },
    toDynamicInfo(id) {
      this.$router.push(`/dynamicInfo?id=${id}`)
    },
    getHospitalDetail() {
      this.$Apis.hospitalDetail().then(res => {
        if (res.code === 200) {
          this.hospitalInfo = res.data
          this.$store.commit('updateInfo', {
            name: 'hospitalInfo',
            value: res.data
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.layout-box {
  height: calc(95vh - 16vw);
}

.middle-box {
  height: 418px;
  margin: 10px 12px;
  background: url('../../assets/images/user/menu_bg.png') center center no-repeat;
  background-size: 100% 100%;
  overflow-y: auto;
  border-radius: 12px;
}

.guanhuai {
  position: absolute;
  right: 10px;
  top: 65%;
  z-index: 666;
  border-radius: 5px;

  .guanhuai_detail {
    width: 45px;
    height: 148px;
    background: #0bcda8;
    border-radius: 40px;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    vertical-align: center;
    color: #ffffff;
    letter-spacing: 4px;

    .pic {
      width: 30px;
      margin: 0 0 .06rem .08rem;
      padding-top: 10px;

      img {
        display: block;
        width: .2rem;
        height: auto;
      }
    }
  }
}

.nameStyle {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}

.identifyStyle {
  font-size: 14px;
  font-weight: 500;
  margin-top: 8px;
  color: #ffffff;
}

.imgStyle {
  width: 60px;
  height: 60px;
  margin-top: 24px;
  margin-left: 15px;
}

.add-patient {
  margin-left: 20px;
  margin-top: 25px;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
}

.bgimg {
  width: 95%;
  margin: 10px;
  height: 110px;
  background: url('../../assets/images/inpatient-bj.png') center center no-repeat;
  background-size: cover;
  border-radius: .1rem;
}

.img {
  width: 47%;
  padding: 10px;
}

.grid-icon {
  font-size: 30px;
  display: block;
  margin-bottom: 10px;
}

.grid-text {
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: #333333;
}

.cell-left-icon {
  font-size: 20px;
  margin-right: 10px;
}

.van-tabbar-item__icon {
  margin-bottom: 0 !important;
  margin-top: 8px;
}

.van-tabbar-item {
  font-size: 14px !important;
}

.van-tabbar {
  height: auto !important;
  padding-top: 10px;
}

.tabbar-title {
  margin: 5px 0 8px;
}

.tabbar-icon {
  font-size: 24px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.iconfont-blue {
  color: #1677ff;
}

/* .van-swipe-item{
    color: #1677ff;
  }
  .van-notice-bar{
    color: #1677ff;
  } */

.layout-title-box {
  height: 180px;
  background: url('../../assets/images/test/bg-1.png') center center no-repeat;
  background-size: cover;
  position: relative;
  margin-bottom: 10px;
}

.layout-title-img {
  margin: 0 12px;
  height: 170px;
  border-radius: 10px;
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  border-radius: 12px;
  overflow: hidden;
}

.menu-box {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}

.menu-data {
  width: 25%;
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
